module.exports = __webpack_public_path__ + "banquet/components/images/banquet_white_logo.201e11a7ab7a447a44fa16e250d3cd8f.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/banquet_white_logo.svg
// module id = 1696
// module chunks = 1